<div #mapArea style="width: 100%; height: 100%;">
    <slot name="esri-view-user-storage"></slot>
</div>
<slot name="top-left" #topLeft></slot>
<slot name="top-right" #topRight></slot>
<slot name="bottom-right" #bottomRight></slot>
<slot name="bottom-left" #bottomLeft></slot>
